module.exports = __webpack_public_path__ + "static/media/ta-pro-03.dc878090.png";